import { FetchAPI, FetchAPIState, FormAPI, ModalService, PanelAPI, SwitchAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnAfterFetch, OnChange } from '@philips-internal/oswald-ui-core/lib/client';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SecurityAuthenticationAliases } from '../../codegen/constants/aliases/security-authentication-aliases';
import { Inject } from '@odinjs/odin';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { FragmentNames } from '../../codegen/constants';
import { MfaStatus, TwoFactorVO } from '../../interfaces/security-authentication';
import { showToastNotificationError } from '../../utils/toast-notification-utils';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { mfaExpressions, mfaModals } from '../../constants/security-authentication';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.SECURITY_AUTHENTICATION })
export default class SecurityAuthenticationController extends BaseController {

  @Inject(SecurityAuthenticationAliases.FETCH_SECURITY_AUTHENTICATION)
    fecthSecurityAuthenticationFetcheAPI!: FetchAPI;

  @Inject(SecurityAuthenticationAliases.FORM_SECURITY_AUTHENTICATION)
    formSecurityAuthenticationFormAPI!: FormAPI;

  @Inject(SecurityAuthenticationAliases.SWITCH_SECURITY_AUTHENTICATION)
    switchSecurityAuthenticationSwitchAPI!: SwitchAPI;

  @Inject(SecurityAuthenticationAliases.TEXT_SWITCH_MFA)
    textSecurityAuthenticationAPI!: TextAPI;

  @Inject(SecurityAuthenticationAliases.PANEL_LOADER_MFA_SWITCH)
    panelLoader!: PanelAPI;

  @OnAfterFetch({ target: SecurityAuthenticationAliases.FETCH_SECURITY_AUTHENTICATION })
  fetchStatus(event: FetchAPIState): void {
    this.context.set({ automaticChange: true });
    const mfa = event.data as unknown as MfaStatus
    this.switchSecurityAuthenticationSwitchAPI.setValue(mfa.isMfaEnabled);
  }

  @OnChange({ target: SecurityAuthenticationAliases.SWITCH_SECURITY_AUTHENTICATION })
  onChangeSecurityAuthentication(event: ChangeEvent<boolean>): void {
    if (this.context.get('automaticChange')) {
      this.context.set({ automaticChange: false });
      return;
    }

    if (event.value) {
      this.enableAuthentication(event);
    } else {
      const modalContext = { name: mfaModals.DEACTIVATION };
      this.openAuthenticationModal(modalContext, FragmentNames.SECURITY_DEACTIVATION_MODAL);
    }
  }

  private enableAuthentication(event: ChangeEvent<boolean>): void {
    this.panelLoader.setVisible(true);
    HttpService.put(APPLICATION_ENDPOINTS.PUT_REQUEST_AUTHENTICATION, {})
      .then(response => {
        const twoFactor = response.body as TwoFactorVO;
        if (!twoFactor.link || !twoFactor.secret) {
          this.rollbackSwitchValue(event);
          return;
        }
        const modalContext = {
          name: mfaModals.ACTIVATION,
          twoFactor: twoFactor
        };
        this.openAuthenticationModal(modalContext, FragmentNames.SECURITY_ACTIVATION_MODAL);
      })
      .catch(() => {
        this.rollbackSwitchValue(event);
      })
      .finally(() => {
        this.panelLoader.setVisible(false);
      });
  }

  rollbackSwitchValue(event: ChangeEvent<boolean>): void{
    showToastNotificationError(MessageService.translate(mfaExpressions.SYSTEM_INTERNAL_ERROR));
    this.context.set({ automaticChange: true });
    const switchOldValue = event.oldValue ? event.oldValue : false;
    this.switchSecurityAuthenticationSwitchAPI.setValue(switchOldValue);
  }

  openAuthenticationModal(mfaContext: object, fragmentName: string): void {
    ModalService.openDialog({
      closeable: true,
      contextData: { mfaContext },
      fragment: fragmentName,
      id: mfaModals.MODAL,
      onClose: () => {
        this.fecthSecurityAuthenticationFetcheAPI.forceFetch();
      }
    });
  }

}
